export default __webpack_public_path__ + "static/media/nidal_zeineh.84e177d8.jpeg";